var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.35 15.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00AB84!important;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "updist"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "current",
    points: "10.56 11.63 10.56 13.18 8.4 13.18 8.4 15.53 6.85 15.53 6.85 13.18 4.69 13.18 4.69 11.63 6.85 11.63 6.85 9.27 8.4 9.27 8.4 11.63 10.56 11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19,7.65h11a.73.73,0,0,0,.55-.25.85.85,0,0,0,.23-.6.82.82,0,0,0-.23-.6L8.22.25A.71.71,0,0,0,7.67,0a.73.73,0,0,0-.55.25l-5.48,6a.84.84,0,0,0-.23.6.85.85,0,0,0,.23.6A.73.73,0,0,0,2.19,7.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 15.35,
    height: 15.53
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdist);
export default __webpack_public_path__ + "static/media/updist.a4b040d29e2643d8dcaa0715ffd1b19d.svg";
export { ForwardRef as ReactComponent };